'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _neptune = require('./neptune');

var _neptune2 = _interopRequireDefault(_neptune);

var _swiperBundle = require('swiper/swiper-bundle');

var _swiperBundle2 = _interopRequireDefault(_swiperBundle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_neptune2.default.swiper = {

  init: function init(p) {

    p = p || document;

    _n.qsa('[data-swiper], [neptune-swiper]', p).forEach(function (el) {

      console.log('swiper init', p, el);

      if (!el.classList.contains('swiper-container-initialized') && !el.classList.contains('swiper-hold') && !el.swiper) _neptune2.default.swiper.swiper(el);
    });
    // setTimeout(Neptune.swiper.reset,150)
  },

  reset: function reset() {

    document.querySelectorAll('[data-swiper]').forEach(function (el) {

      if (!el.hasOwnProperty('swiper')) return;

      if (el.hasAttribute('data-swiper-reset-widths')) {
        el.querySelectorAll('.swiper-slide').forEach(function (slide) {
          slide.style.width = slide.firstElementChild.offsetWidth + "px";
          slide.style.opacity = 1;
        });
      }
      el.swiper.update();
    });
  },

  swiper: function swiper(el) {

    if (!el) return;
    if (!!el.swiper) return;

    if (el.querySelectorAll('.swiper-slide').length == 1) return;

    var config = {
      scrollbar: {
        el: '.swiper-scrollbar',
        hide: true
      },
      on: {
        init: function init() {
          _n.qsa('.lazyloading', el).forEach(function (ll) {
            ll.classList.remove('lazyloading');
            ll.classList.add('lazyload');
          });
        }
      }
    };

    if (!!el.getAttribute('neptune-swiper')) {
      config = Object.assign(USON.parse(el.getAttribute('neptune-swiper'))[0], config);
      config = _neptune2.default.swiper.setMethods(config);
    }

    el.the_swiper = true;

    window.the_el = el;

    for (var ai in el.attributes) {

      if (!ai) continue;

      if (!!el.attributes[ai].nodeName && el.attributes[ai].nodeName.indexOf('data-swiper-') > -1) {

        var key = el.attributes[ai].nodeName.replace('data-swiper-', '');
        var key = key.replace(/-([a-z])/g, function (g) {
          return g[1].toUpperCase();
        });

        var val = el.attributes[ai].nodeValue;

        if (val == 'true') val = true;
        if (val == 'false') val = false;

        if (typeof val != 'boolean') {

          try {
            if (!isNaN(val)) val = parseFloat(val);
          } catch (e) {
            // console.log(e)
          }
          try {
            if ((0, _typeof3.default)(JSON.parse(val)) == 'object') val = JSON.parse(val);
          } catch (e) {
            // console.log(e)
          }
        }

        config[key] = val;
      }
    }

    // console.log(el,config)

    el.swiper = new _swiperBundle2.default(el, config);

    if (el.querySelectorAll('.swiper-next').length) {
      el.querySelector('.swiper-next').addEventListener('click', function () {
        el.swiper.slideNext();
      });
    }
    if (el.querySelectorAll('.swiper-prev').length) {
      el.querySelector('.swiper-prev').addEventListener('click', function () {
        el.swiper.slidePrev();
      });
    }

    el.swiper.on('imagesReady', function (swiper) {

      el.classList.remove('o-0');
      el.querySelectorAll('.product-tile.is-hidden').forEach(function (tile) {
        tile.classList.remove('is-hidden');
      });
      // for(var i=0; i<el.querySelectorAll('.product-tile.is-hidden').length; i++){
      //     var tile = el.querySelectorAll('.product-tile.is-hidden')[i]
      //     tile.classList.remove('is-hidden')
      // }
    });
    el.classList.remove('o-0');

    el.swiper.on('slideChangeTransitionEnd', function (swiper) {

      if (!!el.getAttribute('data-onchange')) {
        window[el.getAttribute('data-onchange')](swiper);
      }
    });
  },

  setMethods: function setMethods(object) {
    // Set a method within a string in JSON by prepending it with "method:"
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = Object.entries(object)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var _ref = _step.value;

        var _ref2 = (0, _slicedToArray3.default)(_ref, 2);

        var key = _ref2[0];
        var value = _ref2[1];

        switch (typeof value === 'undefined' ? 'undefined' : (0, _typeof3.default)(value)) {
          case 'object':
            {
              _neptune2.default.swiper.setMethods(value);
              break;
            }
          case 'string':
            {
              if (value.includes('method:')) {
                var parameters = value.substring(value.indexOf("(") + 1, value.indexOf(")"));
                var statement = value.substring(value.indexOf("{") + 1, value.lastIndexOf("}"));
                object[key] = new Function(parameters, statement);
              }
              break;
            }
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return object;
  }
};
window.Neptune = _neptune2.default;

exports.default = _neptune2.default.swiper;